<template>
  <div class="clipp-layout">
    <navbar
      :route="route"
      v-if="!loadingInit"
      :logged="menus.length > 0"
      :label-message="resellerMessage"
    />
    <print-header></print-header>

    <div :class="menus.length > 0 ? 'container-app logged' : 'container-app'">
      <b-container id="clipp-container-app" v-if="!loadingInit">
        <unauthorized-feature :menus="menus"></unauthorized-feature>
        <redirect-360 />
        <slot />
      </b-container>
    </div>

    <navbar-footer v-if="!loadingInit" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ResellerMixin from '@/modules/Application/mixins/ResellerMixin';

import UnauthorizedFeature from '../UnauthorizedFeature';
import Navbar from '../Navbar';
import NavbarFooter from '../NavbarFooter';
import Redirect360 from '../Redirect360';
import { PrintHeader } from '../Print';

export default {
  name: 'Layout',
  components: {
    Navbar,
    NavbarFooter,
    UnauthorizedFeature,
    Redirect360,
    PrintHeader,
  },
  mixins: [
    ResellerMixin,
  ],
  props: {
    public: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      route: null,
    };
  },
  updated() {
    this.route = this.$route;
    this.getResellerMessage(this.client);
  },
  computed: {
    ...mapState('application', ['menus']),
    ...mapState('client', ['client']),
    loadingInit() {
      return !(this.menus.length > 0) && !this.public;
    },
  },
  watch: {
    client(value) {
      if (value.id) {
        this.getResellerMessage(value);
      }
    },
  },
};
</script>
